<template>
  <div class="">
    <div class="secdbanner"></div>
    <div class="section">
      <div class="crumbsModel">
        您现在的位置： <a :href="$store.state.home">首页</a>
        <a class="no-cache" href="https://cart.nstl.gov.cn">申请单</a>
      </div>
      <div class="section clearfix">
        <div class="techprocess">
          <ul class="clearfix">
            <li class="width400 active">
              <span @click="gocart()"><b>1</b>选择文献</span>
              <u></u>
            </li>
            <li class="width400 active">
              <span><b>2</b>确认支付</span>
              <u></u>
            </li>
            <li class="width400 active">
              <span><b>3</b>支付成功</span>
              <u></u>
            </li>
          </ul>
        </div>
        <div class="bordershadow">
          <div class="subscribebox">
            <div class="subscrirow">
              <div class="searchfuntion">
                <div class="confirmpayment">
                  <div class="echargeHints">
                    <h3 class="success"><i class="iconfont icon-chenggong"></i><b>恭喜您支付成功</b></h3>
                    <div class="hintstips">
                      <p v-show="orderIdShow">
                        申请号：<span id="paySuccess_orderId">{{ requestId }}</span>
                      </p>
                      <p>我们将在&nbsp;<font class="ntips">24</font>&nbsp;小时之内为您发送。</p>
                      <p>前往<a class="no-cache" :href="$store.state.selfservice + '/selfservice/docorder'">申请查询</a>查看</p>
                    </div>
                    <p class="hintstips"><a :href="$store.state.home">返回首页</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      requestId: '',
      merchantId: '',
      orderIdShow: false
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    requestId: function(val) {
      if (val != undefined && val != '') {
        this.orderIdShow = true
      }
    }
  },
  //方法集合
  methods: {
    gocart() {
      this.$router.replace('/cart/select')
    },
    successWebPay() {
      // https://api.nstl.gov.cn/api/notify/upay/success?requestId=this.requestId
      this.$http
        .post('/cart/webPaySuccess.shtml', this.$queryString.stringify({ requestId: this.requestId }), {
          emulateJSON: true
        })
        .then(response => {})
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //alert(this.$route.query.requestId)
    // if (!this.$store.state.isLogin) {
    //    this.$router.replace('/cart/select')
    // } else {
    this.requestId = this.$route.query.requestId
    this.merchantId = this.$route.query.merchantId
    if (this.requestId) {
      this.successWebPay()
    }
    // }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.echargeHints .hintstips > p {
  font-size: 20px;
  color: #000;
}

.echargeHints > h3 {
  font-size: 24px;
}
.echargeHints .hintstips > p > a {
  font-size: 20px;
}
.ntips {
  font-style: italic;
  font-size: 50px;
  color: red;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/cart/success.vue